<script>
/* jshint esversion: 6 */
import { inject } from 'vue';

export default{
    name: 'Button',
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
	},
    setup(props) {
        const buttonFunctionParent = inject('buttonFunctionParent');

        function buttonClick(getfunction) {
            var toParent = {
                'id': props.schemaId,
                'functionVal': getfunction.functionVal,
                'argumentsVal': getfunction.argumentsVal
            };
            if (buttonFunctionParent) {
                buttonFunctionParent(toParent);
            }
        }

        return {
            buttonClick
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .singleButton(
        :class="[schema.class,disabled === true ? 'fieldDisabled': '']"
    )
        label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
        div(:style="disabled === true ? 'opacity:0.5; cursor: not-allowed': ''")
            button(
                v-if="schema.onclick" 
                @click="buttonClick(schema.onclick)" 
                :class="schema.buttonClass"
                :style="disabled === true ? 'pointer-events:none': ''"
            )
                    | {{ schema.buttonLabel }}
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
</template>